/**
 * PostHog Page View Tracker
 *
 * Automatically tracks page views with TanStack Router
 * Follows PostHog 2025 best practices for SPA page view tracking
 *
 * This component gracefully handles missing PostHog configuration
 * by checking if PostHog is enabled before attempting to track events.
 */

import { useEffect } from 'react'
import { useLocation } from '@tanstack/react-router'
import { posthog, isPostHogEnabled } from '@/lib/posthog'

export function PostHogPageView() {
  const location = useLocation()

  useEffect(() => {
    // Gracefully skip tracking if PostHog is not configured
    if (!isPostHogEnabled()) {
      return
    }

    try {
      // Track page view with current path
      // PostHog will automatically include $current_url, $pathname, etc.
      posthog.capture('$pageview', {
        $current_url: window.location.href,
      })

      console.log('[PostHog] Page view tracked:', location.pathname)
    } catch (error) {
      // Silently fail if PostHog is not properly initialized
      console.warn('[PostHog] Failed to track page view:', error)
    }
  }, [location.pathname])

  return null // This component doesn't render anything
}
